import type { OrderLeg } from '@thinkalpha/trading-ws-client/contracts/order.js';
import type { LegsQueryOptions } from 'src/features/legsHoverCard/types';
import { instrumentToString } from 'src/lib/instrumentUtils';

const getLegsRevision = (legs: OrderLeg[]): string =>
    JSON.stringify(
        legs.map((leg) => [instrumentToString(leg.instrument), leg.side, leg.quantityRatio, leg.openClose ?? null]),
    );

export const getBlotterLegsQueryOptions = (orderId: string, legs: OrderLeg[] | undefined): LegsQueryOptions => {
    if (legs === undefined) return null;

    return {
        queryKey: ['blotter-order-legs', orderId, getLegsRevision(legs)],
        queryFn: () => Promise.resolve(legs),
        staleTime: Infinity,
    };
};
